export const userInputs = [
    {
        id: 1,
        name: "name",
        label: "Name",
        type: "text",
        placeholder: "john_doe",
    },


    {
        id: 3,
        name: 'phone',
        label: "Phone",
        type: "tel",
        placeholder: "+91 234 567 8921",
    },
    {
        id: 4,
        name: 'location',
        label: "Address",
        type: "text",
        placeholder: "Elton St. 216 NewYork",
    },
    {
        id: 5,
        name: 'std',
        label: "Standard",
        type: "text",
        placeholder: "Enter your Standard",
    },


];



export const teacherInputs = [
    {
        id: 1,
        name: "name",
        label: "Name",
        type: "text",
        placeholder: "john_doe",
    },


    {
        id: 3,
        name: 'phone',
        label: "Phone",
        type: "tel",
        placeholder: "+91 234 567 8921",
    },
    {
        id: 4,
        name: 'location',
        label: "Address",
        type: "text",
        placeholder: "Elton St. 216 NewYork",
    },
    {
        id: 5,
        name: 'std',
        label: "Standard",
        type: "text",
        placeholder: "Enter your Standard",
    },
];
